import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/home/form_bg.png")